import { IVendaNacionalNCMReceber } from '../../../../../../../../../../../interfaces/IVendaNacional';
import { Col, Row } from 'react-dsgov';
import styles from './itemVendaNacional.module.scss';
import { formatCurrency } from '../../../../../../../../../../../utils/formatCurrency';
import { BrDivider } from '@govbr-ds/react-components';
import { formatNumber } from '../../../../../../../../../../../utils/formatNumber';

interface IItemVendaNacionalProps {
  ncm: IVendaNacionalNCMReceber;
}

const ItemVendaNacional = ({ ncm }: IItemVendaNacionalProps) => {
  return (
    <>
      <Row className={styles.row}>
        <Col>
          <span className={styles.label}>Código NCM</span>
          <p className={styles.text}>{ncm?.codigoNCM}</p>
        </Col>
        <Col>
          <span className={styles.label}>Unidade de Medida</span>
          <p className={styles.text}>{ncm?.unidadeMedida}</p>
        </Col>
        <Col>
          <span className={styles.label}>Quantidade Vendida</span>
          <p className={styles.text}>{formatNumber(ncm?.quantidade)}</p>
        </Col>
        <Col>
          <span className={styles.label}>Receita Bruta de Venda (R$)</span>
          <p className={styles.text}>{formatCurrency(ncm?.receitaBrutaVenda)}</p>
        </Col>
      </Row>
      <Row className={styles.row}>
        <Col>
          <span className={styles.label}>Preço Praticado (R$)</span>
          <p className={styles.text}>{formatCurrency(ncm?.precoPraticado)}</p>
        </Col>
        <Col>
          <span className={styles.label}>Preço Corrente (R$)</span>
          <p className={styles.text}>{formatCurrency(ncm?.precoCorrente)}</p>
        </Col>
        <Col>
          <span className={styles.label}>O bem mineral é oriundo de rejeitos?</span>
          <p className={styles.text}>{ncm?.isRejeito ? 'Sim' : 'Não'}</p>
        </Col>
        <Col>
          <span className={styles.label}>A substância possui uso específico?</span>
          <p className={styles.text}>{ncm?.hasUsoEspecifico ? 'Sim' : 'Não'}</p>
        </Col>
        <Col></Col>
      </Row>
      <div className={styles.movimentacao}>
        <Row>
          {ncm.tributosValores?.map((item) => (
            <Col key={item.nome} className={styles.tributosContainer}>
              <span className={styles.label}>{item.nome}</span>
              <p className={styles.text}>{formatCurrency(item.valor || '')}</p>
            </Col>
          ))}
        </Row>
        <div className={styles.metodoDivider}>
          <BrDivider />
        </div>
        <div className={styles.infoContainer}>
          <div>
            <span className={styles.label}>Receita Líquida (R$)</span>
            <p className={styles.text}>{formatCurrency(ncm?.receitaBrutaVenda - ncm?.totalTributosIncidentes || '')}</p>
          </div>

          <div>
            <span className={styles.label}>Quantidade a abater da aquisição de terceiros</span>
            <p className={styles.text}>{formatNumber(ncm?.quantidadeAquisicaoTerceiros)}</p>
          </div>
          <div>
            <span className={styles.label}>Valor total a abater da aquisição de terceiros (R$)</span>
            <p className={styles.text}>{formatCurrency(ncm?.valorAquisicaoTerceiros ?? '')}</p>
          </div>
        </div>
        <div className={styles.infoContainer}>
          <div>
            <span className={styles.label}>Preço Utilizado (R$)</span>
            <p className={styles.text}>
              {'Preço ' + ncm?.precoUtilizadoDescricao + ': ' + formatCurrency(ncm?.precoUtilizado ?? '')}
            </p>
          </div>
          <div>
            <span className={styles.label}>Deduções (R$)</span>
            <p className={styles.text}>{formatCurrency(ncm?.totalDeducoes ?? '')}</p>
          </div>
          <div>
            <span className={styles.label}>Base de Cálculo (R$)</span>
            <p className={styles.text}>{formatCurrency(ncm?.baseCalculo ?? '')}</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default ItemVendaNacional;
